import { useCallback, useState } from 'react';

import type { CreateIssueProps, CreateIssueResponse } from '../__types__/apiUtils';

import { createIssue } from './apiUtils';

export const useCreateSingleWorkItem = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const createSingleWorkItemHandler = useCallback(
		async ({
			cloudId,
			issueBody,
		}: CreateIssueProps): Promise<{ isSuccess: boolean; response: CreateIssueResponse | null }> => {
			setLoading(true);
			setError(null);
			try {
				const result = await createIssue({ cloudId, issueBody });
				if (result && result.id) {
					return { isSuccess: true, response: result };
				} else {
					setError('Failed to create issue');
					return { isSuccess: false, response: null };
				}
			} catch (err: any) {
				const message = 'Failed to create issue';
				setError(message);
				return { isSuccess: false, response: null };
			} finally {
				setLoading(false);
			}
		},
		[],
	);

	return { createSingleWorkItemHandler, loading, error };
};
